import {isUserPremium} from '@Libraries/user.library';
import {useGetTeamCredits} from '@Hooks/useGetTeamCredits';
import {useGetPAYGUserCredits} from '@Hooks/useGetPAYGUserCredits';

export function getCreditsForImageBGR(): number {
  const isPremiumUser = isUserPremium();
  let credits;
  if (isPremiumUser) {
    credits = useGetTeamCredits() ?? 0;
  } else {
    const paygUserCredits = useGetPAYGUserCredits();
    credits = paygUserCredits.imageBGRCredits ?? 0;
  }

  return credits;
}

export function getCreditsForVideoBGR(): number {
  const isPremiumUser = isUserPremium();
  let credits;
  if (isPremiumUser) {
    credits = useGetTeamCredits() ?? 0;
  } else {
    const paygUserCredits = useGetPAYGUserCredits();
    credits = paygUserCredits.videoBGRCredits ?? 0;
  }

  return credits;
}

export function isImageBGRAllowedForPAYGUser(): boolean {
  const paygUserCredits = useGetPAYGUserCredits();
  return paygUserCredits.isImageBGREnabled ?? false;
}

export function isVideoBGRAllowedForPAYGUser(): boolean {
  const paygUserCredits = useGetPAYGUserCredits();
  return paygUserCredits.isVideoBGREnabled ?? false;
}